import { cloneDeep } from 'lodash';

const SET_EBOOK_ORDER_SUCCESS = 'SET_EBOOK_ORDER_SUCCESS';
const SET_EBOOK_ORDER_FAILURE  = 'SET_EBOOK_ORDER_FAILURE';
const CLEAR_EBOOK_ORDER_SUCCESS = 'CLEAR_EBOOK_ORDER_SUCCESS';

const initialStateEbookOrder = '';

export default function reducer(state = cloneDeep(initialStateEbookOrder), action) {
	switch (action.type) {
		case SET_EBOOK_ORDER_SUCCESS:
			return 'success';
		case SET_EBOOK_ORDER_FAILURE:
			return 'error';
		case CLEAR_EBOOK_ORDER_SUCCESS:
			return '';
		default:
			return state;
	}
}

export function clearEbookOrderSuccess(){
  return { type: CLEAR_EBOOK_ORDER_SUCCESS }
}

export function setEbookOrderFailure(){
  return { type: SET_EBOOK_ORDER_FAILURE }
}

export function setEbookOrderSuccess(){
  return { type: SET_EBOOK_ORDER_SUCCESS }
}



// WEBPACK FOOTER //
// ./src/modules/ebook_order_success.js